<template>
  <v-card
      :elevation="elevation"
      min-height="100%"
      style="position: relative"
      height="100%"
      class="ma-0 pa-0 product mt-2"
      outlined
  >
    <div class="white--text discount">
      <p class="mt-1">
        <strong v-if="discountType === percentual"> {{ discount }}%</strong>
        <strong v-else>
          {{
            discount.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })
          }}
        </strong>
      </p>
    </div>

    <v-row col="12" class="d-flex">
      <v-col cols="6"
             class="pa-1 d-flex justify-start">
        <v-col cols="6">
          <v-img
              class="white--text align-end img"
              max-width="100%"
              height="100%"
              :src="env_url + item.productPic"
          >
          </v-img>
        </v-col>
        <v-col cols="6">
          <v-card-title class="card-title pl-1">
            {{ formatName(item.productName) }}
            <br/>
          </v-card-title>
        </v-col>
      </v-col>

      <v-col cols="6" class="ma-0 pa-0">
        <v-col cols="12" class="ma-0 pa-0 px-2 sku" v-for="(sku, index) in item.skus"
               :key="sku.id">
          <v-row col="12" class="ma-0 pa-0 px-2 ">
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex ma-0 pa-0 mt-3 px-3">
              <strong>Sku:</strong>
              <div class="ml-1" v-for="att in sku.attributes" :key="att.id">
                <strong class="mr-1 sku-name">{{ att.name }}</strong>
              </div>
            </v-col>

            <v-col cols="6" sm="6" md="6" lg="6">
              <strong class="mb-1 price-de">
                De: {{
                  sku.differentValue.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </strong>
            </v-col>

            <v-col cols="6" sm="6" md="6" lg="6">
              <strong class="mb-1 price-por">
                Por: {{
                  priceDiscount(sku.differentValue).toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </strong>
            </v-col>
          </v-row>
          <v-divider v-if="index < (item.skus.length - 1)" class="divider"></v-divider>
        </v-col>

      </v-col>
    </v-row>
  </v-card>
</template>

<style scoped>
.img {
  border-radius: 5px;
}

.price-de {
  color: #6D7989 !important;
  text-decoration: line-through;
  font-weight: 700;
  font-size: 16px !important;
}

.price-por {
  font-weight: 700;
  font-size: 16px !important;
}
.sku-name {
  background: #000000;
  color: #FFFFFF;
  padding: 5px;
  border-radius: 3px;
}

.discount {
  position: absolute;
  background: #BC0000;
  width: 80px;
  height: 27px;
  top: 15px;
  right: 5%;
  left: 20px;
  z-index: 10;
  text-align: center;
  align-self: center;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}
.divider{
  width: 80%!important;
  margin-left: 15px!important;
}
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.card-title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  font-weight: 600 !important;
  min-height: 32px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word !important;
  font-size: 16px !important;
  line-height: 22px;
  letter-spacing: 0;
  text-align: left;
  color: #2D3038;
}

.v-sheet button.v-btn.v-size--default:not(.v-btn--icon):not(.v-btn--fab) {
  padding: 3px 3px !important;
}

@media screen and (max-width: 700px) {
  .product {
    min-width: 160px !important;
  }
}

</style>

<script>
import ApiService from "../../../../services/ApiService";
import FormatText from "../../../../Utils/FormatText";
import moment from "moment";

export default {
  name: "ImageCard",
  components:{

  },
  props: {
    elevation: Number,
    item: Object,
    textMessage: String,
    cancelBtn: String,
    okbtn: String,
    env_url: String,
    discountType: {type: Number, default: 1},
    discount: {type: Number, default: 0},
  },

  data: () => ({
    hoverImage: false,
    loading: false,
    shortPriceSku: [],
    apiService: new ApiService(),
    percentage: 0,
    percentual: 1,
    real: 2,
  }),

  created() {
    if (this.item.promotionStart && this.item.promotionEnd) {
      if (
          moment().isAfter(moment(this.item.promotionStart)) &&
          moment().isBefore(moment(this.item.promotionEnd))
      ) {
        this.percentage = this.item.percentage;
      }
    } else {
      if (this.item.percentage) {
        this.percentage = this.item.percentage;
      }
    }


  },
  mounted() {

  },

  methods: {
    removeProduct(){
      this.$emit('remove-product', this.item.productId)
    },
    priceDiscount(differentValue) {
      if (this.discountType === this.percentual) {
        return differentValue - ((this.discount / 100) * differentValue)
      }
      return differentValue - this.discount
    },
    formatName(productName) {
      return FormatText.capitalizeFirst(productName)
    },
    descriptionSku(sku) {
      if (!sku.attributes) {
        return ``;
      }
      const atributoName = sku.attributes.find(
          (x) => x.attribute.type === "Texto"
      );
      if (atributoName) {
        return `${atributoName.name} - `;
      }
      const atributoCor = sku.attributes.find(
          (x) => x.attribute.type === "Cor"
      );
      if (atributoCor) {
        return `${atributoCor.name} - `;
      }
      return "";
    },
    close() {
      this.$emit("close");
    },

    action() {
      this.$emit("action");
    },
  },
};
</script>
